"use client";

import { Sidebar, SidebarContent } from "@/components/ui/sidebar";
import type { NavGroup } from "./eventNavConfig";
import { SidebarLogo } from "./SidebarLogo";
import { SidebarNavGroup } from "./SidebarNavGroup";

interface AppSidebarProps {
  navGroups: NavGroup[];
}

export function AppSidebar({ navGroups }: AppSidebarProps) {
  return (
    <Sidebar
      collapsible="icon"
      className="bg-white [&_[data-sidebar=sidebar]]:bg-white border-r-0! print:hidden"
    >
      <SidebarLogo />
      <SidebarContent className="flex flex-col items-start gap-5 p-4.5 group-data-[collapsible=icon]:px-4 overflow-y-auto border-r border-neutral-200">
        {navGroups.map((group, i) => (
          <SidebarNavGroup key={group.title ?? i} group={group} />
        ))}
      </SidebarContent>
    </Sidebar>
  );
}
